import { EventEmitter } from '@angular/core';
var SuccessStepComponent = /** @class */ (function () {
    function SuccessStepComponent() {
        this.backToLogin = new EventEmitter();
    }
    return SuccessStepComponent;
}());
export { SuccessStepComponent };
